<template>
    <div v-if="item" class="md-content">
        <toolbar title="Informations de la catégorie de produit" isEdit="true" @edit="onEdit" isDelete="true" @delete="deleteConfirmation">
            <md-menu md-size="auto" md-align-trigger>
                <md-button class="md-mr-3 md-primary md-icon-button" md-menu-trigger><md-icon>more_vert</md-icon></md-button>
                <md-menu-content>
                    <md-menu-item @click="onTranslation">Traduire</md-menu-item>
                </md-menu-content>
            </md-menu>
        </toolbar>

        <div class="md-mt-5 md-layout md-gutter md-alignment-top-center">
            <div class="md-layout-item md-size-90 ">
                <div class="md-layout md-alignment-top-right">
                    <md-switch v-model="item.isActive" class="md-primary" disabled>Actif</md-switch>
                </div>
            </div>

            <div class="md-layout-item md-size-45 md-small-size-90 ">
                <div class="md-layout md-layout-item md-size-90 ">
                    <h3>Nom</h3>
                </div>
                <label>{{item.name}}</label><br>

                <div class="md-layout md-layout-item md-size-90 title">
                    <h3>Clef de tri</h3>
                </div>
                <label>{{item.sortingKey}}</label><br>
            </div>

            <div class="md-layout-item md-size-45 md-small-size-90 ">
                <div class="md-layout md-layout-item md-size-90 ">
                    <h3>Titre / I18N</h3>
                </div>
                <label>{{item.title}}</label><br>
                <label>{{item.i18N}}</label><br>

                <div class="md-layout md-layout-item md-size-90 title">
                    <h3>Commentaires</h3>
                </div>
                <label>{{item.comment}}</label><br><br>
            </div>
            
            <div class="md-layout-item md-size-90 md-mt-5 ">
                <span class="md-caption">Modifié&nbsp;le:&nbsp;{{item.modifiedOn| YYYYMMDD}} </span>
                <span class="md-caption">Par:&nbsp;{{item.modifiedBy}}</span>
            </div>
            <div class="md-layout-item md-size-90 ">
                <span class="md-caption">Créé&nbsp;le:&nbsp;{{item.createdOn| YYYYMMDD}} </span>
                <span class="md-caption">Par:&nbsp;{{item.createdBy}}</span>
            </div>
        </div>

        <md-dialog-confirm :md-active.sync="isDeleteConfirmation"
                           md-title="Attention"
                           md-content="Voulez-vous vraiment supprimer cette enregistrement ?"
                           md-confirm-text="Oui"
                           md-cancel-text="Non"
                           @md-confirm="dataDelete" />
    </div>
</template>
<style scoped>
    h3 {
        margin-right: 5px;
    }

    .title {
        margin-top: 15px;
    }

    label {
        color: rgba(0,0,0,0.54);
        font-size: 16px;
    }
</style>
<script>
    import baseToolbar from '@/components/toolbarBase.vue'

    import { apiSaleProductExtension } from '@/mixins/apiSaleProductExtension.js';
    import { navigateRouteExtension } from '@/mixins/navigateRouteExtension.js';

    export default {
        name: 'productCategoryItem',
        mixins: [apiSaleProductExtension, navigateRouteExtension],
        data: () => ({
            item: {},
            isDeleteConfirmation: false,
        }),
        created: function () {
            $App.event.$on("app_hotkey_ctrlEnter", this.onCtrlEnter);
            $App.event.$on("app_translation_updated", this.onTranslationUpdate);
        },
        destroyed: function () {
            $App.event.$off("app_hotkey_ctrlEnter", this.onCtrlEnter);
            $App.event.$off("app_translation_updated", this.onTranslationUpdate);
        },
        mounted:
            async function () {
                await this.dataRead();
            },
        methods: {
            dataRead: async function () {
                let data = await this.SaleProductCategoryGetById(this.$route.params.id);
                if (data) {
                    this.item = data;
                }
            },
            dataDelete: async function () {
                if (this.item) {
                    let r = await this.SaleProductCategoryDeleteById(this.item.id);
                    if (r) {
                        this.navigateBack({ name: 'productCategory_List' });
                    }
                }
            },
            onEdit: function () {
                this.navigateTo({ name: 'productCategory_Edit', params: { id: this.item.id } });
            },
            onTranslation: function () {
                $App.event.$emit("app_translate", this.item.i18N);
            },
            onTranslationUpdate: function (params) {
                if (this.item.i18N == params) {
                    this.dataRead();
                };
            },
            onCtrlEnter: function (e) {
                this.onEdit();
            },
            deleteConfirmation: function () {
                this.isDeleteConfirmation = true;
            },
            deleteConfirmation: function () {
                this.isDeleteConfirmation = true;
            },
        },
        components: {
            toolbar: baseToolbar
        }
    }
</script>